import React from 'react';
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';
import { MultiSelect } from 'carbon-components-react';

class CustomSelectCarbon extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      formData: {
        ...props.formData
      },
      items: props.schema.items.anyOf.map(item => ({
        id: item.enum[0],
        text: item.title
      })),
      value: '',
      numOfSelectedItems: 0
    };
  }

  onChange (name, value) {
    const selectedItems = [];

    for (let i = 0; i < value.selectedItems.length; i++) {
      if (typeof value.selectedItems[i] === 'string') {
        selectedItems.push(value.selectedItems[i]);
      } else {
        selectedItems.push(value.selectedItems[i].id);
      }
    }

    this.setState(
      {
        value: value.selectedItems,
        numOfSelectedItems: value.selectedItems.length
      },
      () => this.props.onChange(selectedItems)
    );
  }

  render () {
    return (
      <MultiSelect
        type='default'
        className='custom'
        id={this.props.name}
        initialSelectedItems={this.props.formData}
        onChange={value => this.onChange(this.props.name, value)}
        style={{ background: 'white' }}
        items={this.state.items}
        itemToString={item => (item ? item.text : '')}
        placeholder={funcTranslateHelper('customSelectCarbon.PlaceHolder')}
        titleText={this.props.schema.title}
        label={
          this.state.numOfSelectedItems > 0
            ? `${this.state.numOfSelectedItems} seleccionados`
            : funcTranslateHelper('customSelectCarbon.PlaceHolder')
        }
      />
    );
  }
}

export default CustomSelectCarbon;
